



























































































































import Vue from "vue";
import { mapState } from "vuex";
import {
  SectionDict,
  LinkSpec,
  MenuSpec,
  MenuItemSpec,
} from "../store/content";
import events from "../events";

interface AppBarContentComponentData {
  dsections: SectionDict | null;
  dlinks: LinkSpec[] | null;
  dmenu: MenuSpec | null;
  holdRefresh: boolean;
}

export default Vue.extend({
  props: {
    drawer: Boolean,
    visible: Boolean,
    buttonProps: {
      type: Object,
      required: false,
    },
  },

  data: (): AppBarContentComponentData => ({
    dsections: null,
    dlinks: null,
    dmenu: null,
    holdRefresh: false,
  }),

  computed: {
    ...mapState("content", ["sections", "links", "menu"]),
    menuButton() {
      return this.dmenu?.button;
    },

    needsRefresh(): boolean {
      return (
        this.dsections !== this.sections ||
        this.dlinks !== this.links ||
        this.dmenu !== this.menu
      );
    },

    flinks() {
      if (!Array.isArray(this.dlinks)) {
        return [];
      }

      return this.dlinks.filter((l) => l && (!l.if || l.if()));
    },
  },

  methods: {
    updateContent() {
      this.dsections = this.sections;
      this.dlinks = this.links;
      this.dmenu = this.menu;
    },

    scrollToSection(name: string) {
      events.$emit("section", name);
      this.$emit("dismiss");
    },

    menuAction(item: MenuItemSpec, event: MouseEvent) {
      if (item.action) {
        item.action(event);
      }
      if (this.drawer) {
        this.$emit("dismiss");
        this.holdRefresh = true;
      }
    },
  },

  watch: {
    visible(v: boolean) {
      if (!v && this.holdRefresh && this.needsRefresh) {
        this.updateContent();
        this.holdRefresh = false;
      }
    },

    needsRefresh(v: boolean) {
      if (v && !this.holdRefresh) {
        this.updateContent();
      }
    },
  },

  mounted() {
    this.updateContent();
  },
});
